import type { AppDispatch } from "@store";
import { isIsInRedoUndo, markContentDirty } from "@store/story";

/**
 * After a collab undo/redo has reconciled into the store.
 *
 * The Redux undo raises `isInRedoUndo`, and an open Froala writes the restored
 * content into itself only while it is up (Froala.tsx's undo write-back). The
 * Yjs UndoManager reaches the store through the remote-apply path with no
 * flag, so an open Froala kept the undone text — and typing into it saved that
 * text back over the undo. ProseMirror follows any outside change on its own.
 * useDebounceHistory lowers the flag again after 500 ms.
 *
 * The undo also arrives without a changeId bump, so the autosave has to be
 * told (see YjsStoryProvider's undo).
 */
export const settleCollabHistoryStep = (dispatch: AppDispatch): void => {
  dispatch(isIsInRedoUndo(true));
  dispatch(markContentDirty());
};
